import { IPagination } from './app-configuration';

export interface IListing<T> {
  listOfItems: T[];
  pagination: IPagination;
  summary?: any[];
  condition?: any;
  Ids?:number[];
}
export class Listing<T> implements IListing<T>{
  listOfItems: T[];
  summary?: any[];
  pagination: IPagination;
  condition?: any;
  Ids?:number[];
  /**
   *
   */
  constructor(alias?: string, option?: { listOfItems: T[], Summary, pagination: IPagination, summary: any, condition: any }) {
    this[alias] = option.listOfItems;
    this.listOfItems = option.listOfItems;
    this.pagination = option.pagination;
    this.summary = option.summary;
    this.condition = option.condition;
  }
}
export class BaseListing<T = any> implements IListing<T>{
  listOfItems: T[];
  summary?: any[];
  pagination: IPagination;
  condition?: any;
  Ids?:number[];
 
  constructor(option: any) {
    BaseListing.mappingValues(option, this, [
      { Source: 'Pagination', Target: 'pagination' },
      { Source: 'Records', Target: 'listOfItems' },
      { Source: 'Summary', Target: 'summary' },
      { Source: 'Condition', Target: 'condition' },
      { Source: 'Ids', Target: 'Ids' }
    ]);
  }

  public static mappingValues(source: any, target: any, mappingProps?: any[]) {
    if (mappingProps) {
      mappingProps.forEach(prop => {
        if (source.hasOwnProperty(prop.Source))
        {
          target[prop.Target] = source[prop.Source];
          delete source[prop.Source];
        }
      });
    }

    Object.keys(source).forEach(key => target[key] = source[key]);
  }
}

// todo (huyngo): try using this class to match with paging-response of BE
export class PagingListResponse<T> {
  Records: T[];
  Pagination: IPagination

  constructor(option?: BaseListing) {
    if (option) {
      BaseListing.mappingValues(option, this, [ 
        { Source: 'listOfItems', Target: 'Records' },
        { Source: 'pagination', Target: 'Pagination' } 
      ]);
    }
  }
}
